import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { GoogleMap, LoadScript, Marker, DirectionsRenderer, InfoBox } from '@react-google-maps/api';

const API_KEY = process.env.REACT_APP_MAP; // Use your actual API key

const mapContainerStyle = {
  height: '100vh',
  width: '100%',
};


const customMapStyle =
  [
    {
      "featureType": "all",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "weight": "2.00"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#9c9c9c"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#f2f2f2"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#7b7b7b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#46bcec"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#c8d7d4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#070707"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    }
  ]
// Origin and center coordinates
const origin = {
  lat: 25.0505556,
  lng: 55.2148333,
  name: 'The Autograph | I Series',
  pin: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Origin%20Marker.png',
};

const center = {
  lat: origin.lat + 0.11, // Adjust to control the center of the map
  lng: origin.lng,
};

// Destination locations with pins
const destinations = [
  { name: 'Palm Jumeirah', lat: 25.1122, lng: 55.1389, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/palm.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/Palm%20Jumeirah.png" },
  { name: 'Dubai International Airport', lat: 25.2532, lng: 55.3657, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/DXB-airport.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/DXB%20Airport.png" },
  { name: 'Burj Khalifa', lat: 25.1972, lng: 55.2744, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/Burj-Khalifa.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/Burj%20Khalifa.png" },
  { name: 'Emirates Golf Club', lat: 25.0853, lng: 55.1569, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/Emirate-GC.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/EMIRATES%20GOLF%20CLUB.png" },
  { name: 'Mall of the Emirates', lat: 25.1180, lng: 55.2008, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/mall-emirates.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/Mall%20of%20EMIRATES.png" },
  { name: 'Dubai Marina', lat: 25.0800, lng: 55.1401, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/marina.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/Dubai%20marina.png" },
  { name: 'Burj Al Arab', lat: 25.1413, lng: 55.1853, img: 'https://greendirectorydata.s3.us-east-2.amazonaws.com/Map-Landmarks/Burj-arab.png', pin: "https://greendirectorydata.s3.us-east-2.amazonaws.com/Burj%20Al%20Arab.png" },

];

const LocationBanner = () => {
  const [distances, setDistances] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [map, setMap] = useState(null);
  const [zoom, setZoom] = useState(11.5);
  const [showAllMarkers, setShowAllMarkers] = useState(true); // Control marker visibility
  const [hoveredPlace, setHoveredPlace] = useState(null); // Control hovered marker InfoBox

  const onMapLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  useEffect(() => {
    const fetchDistances = async () => {
      const originString = `${origin.lat},${origin.lng}`;
      const destinationsString = destinations.map((d) => `${d.lat},${d.lng}`).join('|');

      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}property/maps`, {
          originString,
          destinationsString,
        });
        console.log('Fetched distances:', response.data);

        if (response.data.body && response.data.body.rows) {
          const results = (response.data.body.rows[0]?.elements || []).map((element, index) => {
            if (!element || !destinations[index]) return null; // Prevent crash

            return {
              name: destinations[index]?.name || "Unknown",
              distance: element.distance?.text || "N/A",
              duration: element.duration_in_traffic?.text || element.duration?.text || "N/A",
              lat: destinations[index]?.lat || 0,
              lng: destinations[index]?.lng || 0,
              img: destinations[index]?.img || "",
              pin: destinations[index]?.pin || "",
            };
          }).filter(Boolean); // Remove null entries

          setDistances(results);
        } else {
          console.error('Invalid response structure:', response.data);
        }
      } catch (error) {
        console.error('Error fetching distance matrix data:', error);
      }
    };

    fetchDistances();
  }, []);

  const handleMarkerClick = (place) => {
    if (window.google && window.google.maps) {
      setSelectedPlace(place);
      setDirectionsResponse(null);
      setShowAllMarkers(false);

      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: { lat: origin.lat, lng: origin.lng },
          destination: { lat: place.lat, lng: place.lng },
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirectionsResponse(result);
            const bounds = new window.google.maps.LatLngBounds();
            bounds.extend(new window.google.maps.LatLng(origin.lat, origin.lng));
            bounds.extend(new window.google.maps.LatLng(place.lat, place.lng));
            if (map) {
              map.fitBounds(bounds);
              setZoom(25);
            }
          } else {
            console.error(`Error fetching directions: ${result}`);
          }
        }
      );
    } else {
      console.error("Google Maps API is not available");
    }
  };

  const handleResetClick = () => {
    setSelectedPlace(null);
    setDirectionsResponse(null);
    setHoveredPlace(null); // Reset hover state
    setShowAllMarkers(true);
    if (map) {
      map.setZoom(11.5);
      map.panTo(center);
    }
  };

  return (
    <div className='location-main-bg-clr'>
      <div className='container'>
        {/* Location Buttons */}
        <div className='location-main-div'>
          <div className='location-button-div'>
          {(distances || []).map((destination, index) => (
            <div className='button-div' key={index}>
              <button onClick={() => handleMarkerClick(destination)}>
                {destination?.name || "Unknown"}
              </button>
            </div>
          ))}
          </div>
        </div>

        {/* Google Map */}
        <div style={{
          marginTop: "1rem"
        }}>
          <LoadScript googleMapsApiKey={API_KEY}>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={center}
              zoom={zoom}
              onLoad={onMapLoad}
              options={{ styles: customMapStyle }}
            >
              {/* Origin Marker - always visible and bouncing */}
              {console.log('origin', origin)}
              <Marker
                position={{ lat: origin.lat, lng: origin.lng }}
                icon={{
                  url: origin.pin,
                }}
                onMouseOver={() => setHoveredPlace(origin)}
                onMouseOut={() => setHoveredPlace(null)}
                animation={window.google && window.google.maps.Animation.BOUNCE}
              >
              </Marker>

              {/* Destination Markers */}
              {showAllMarkers &&
                distances.map((place, index) => (
                  <Marker
                    key={index}
                    position={{ lat: place.lat, lng: place.lng }}
                    icon={{
                      url: place.pin,
                      scaledSize: new window.google.maps.Size(54, 92),
                    }}
                    onMouseOver={() => setHoveredPlace(place)}
                    onMouseOut={() => setHoveredPlace(null)}
                    onClick={() => handleMarkerClick(place)}
                    animation={window.google && window.google.maps.Animation.DROP}
                  >
                    {/* InfoBox on hover */}
                    {hoveredPlace === place && (
                      <InfoBox
                        position={{ lat: place.lat, lng: place.lng }}
                        options={{ closeBoxURL: '', enableEventPropagation: true }}
                      >
                        <div style={{ backgroundColor: '#d2d0d2', padding: '12px', borderRadius: '8px', display: 'flex' }}>
                          <img src={place.img} alt={place.name} style={{ width: '100px', height: 'auto' }} />
                          <div style={{ padding: '0 10px' }}>
                            <h2 style={{ margin: '0 0 10px 0', fontWeight: 'bold', fontSize: '13px' }}>{place.name}</h2>
                            <p>Distance: {place.distance}</p>
                            <p>Duration: {place.duration}</p>
                          </div>
                        </div>
                      </InfoBox>
                    )}
                  </Marker>
                ))}
              {/* Directions Renderer */}
              {directionsResponse && (
                <DirectionsRenderer
                  directions={directionsResponse}
                  options={{
                    polylineOptions: {
                      strokeColor: '#000000',
                      strokeOpacity: 0.8,
                      strokeWeight: 6,
                    },
                  }}
                />
              )}

              {/* Reset Button and Info Section */}
              {selectedPlace && (
                <div
                  style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    zIndex: '5',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <button
                    onClick={handleResetClick}
                    style={{
                      padding: '20px',
                      backgroundColor: 'white',
                      border: '1px solid black',
                      borderRadius: '3px',
                      marginBottom: '10px',
                    }}
                  >
                    Show All Markers
                  </button>
                  <div
                    style={{
                      padding: '20px',
                      backgroundColor: 'white',
                      border: '1px solid black',
                      borderRadius: '3px',
                      marginTop: '10px',
                    }}
                  >
                    <p>Distance: {selectedPlace.distance}</p>
                    <p>Duration: {selectedPlace.duration}</p>
                  </div>
                </div>
              )}
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    </div>
  );
};

export default LocationBanner;
